/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const MyCouponPage = lazyLoad(
  () => import('./index'),
  module => module.MyCouponPage
);
